import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Pages
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import DocumentPage from "./pages/DocumentPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import LegalPage from "./pages/LegalPage";
import AttestationHonneurPage from "./pages/AttestationHonneurPage";
import AttestationHebergementPage from "./pages/AttestationHebergementPage";
import LettreResiliationPage from "./pages/LettreResiliationPage";
import AttestationHonneurSeoPage from "./pages/AttestationHonneurSeoPage";
import DeclarationSituationSeoPage from "./pages/DeclarationSituationSeoPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Main routes */}
        <Route path="/" element={<HomePage />} />
        
        {/* SEO routes with /categorie/ prefix - must be BEFORE dynamic route */}
        <Route path="/categorie/attestation-sur-honneur-pdf" element={<AttestationHonneurSeoPage />} />
        <Route path="/categorie/declaration-situation-personnelle-pdf" element={<DeclarationSituationSeoPage />} />
        
        <Route path="/categorie/:categoryId" element={<CategoryPage />} />
        <Route path="/document/:documentId" element={<DocumentPage />} />
        <Route path="/paiement-reussi" element={<PaymentSuccessPage />} />
        
        {/* SEO Landing Pages */}
        <Route path="/attestation-sur-honneur-pdf" element={<AttestationHonneurPage />} />
        <Route path="/attestation-hebergement-pdf" element={<AttestationHebergementPage />} />
        <Route path="/lettre-resiliation-pdf" element={<LettreResiliationPage />} />
        <Route path="/attestation-sur-honneur-pdf-seo" element={<AttestationHonneurSeoPage />} />
        <Route path="/declaration-situation-personnelle-pdf" element={<DeclarationSituationSeoPage />} />
        
        {/* Legal pages */}
        <Route path="/:pageType" element={<LegalPage />} />
      </Routes>
      <Toaster position="top-center" />
    </BrowserRouter>
  );
}

export default App;
